import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

export const ToastSuccess = (params) => {

  const {
    title,
    position = "bottom-center",
    autoClose = 8000,
    hideProgressBar = false,
    closeOnClick = true,
    pauseOnHover = true,
    className = "text-center toast-notification",
    toastId
  } = params;

  toast.success(`${title}`, {
    position,
    autoClose,
    hideProgressBar,
    closeOnClick,
    pauseOnHover,
    className,
    toastId
  });
};

export const ToastInfo = (params) => {

  const {
    title,
    position = "bottom-center",
    autoClose = 8000,
    hideProgressBar = false,
    closeOnClick = true,
    pauseOnHover = true,
    className = "text-center toast-notification",
    toastId
  } = params;

  toast.info(`${title}`, {
    position,
    autoClose,
    hideProgressBar,
    closeOnClick,
    pauseOnHover,
    className,
    toastId
  });
};

export const ToastWarn = (params) => {

  const {
    title,
    position = "bottom-center",
    autoClose = 8000,
    hideProgressBar = false,
    closeOnClick = true,
    pauseOnHover = true,
    className = "text-center toast-notification",
    toastId
  } = params;

  toast.warning(`${title}`, {
    position,
    autoClose,
    hideProgressBar,
    closeOnClick,
    pauseOnHover,
    className,
    toastId
  });
};

export const ToastError = (params) => {

  const {
    title,
    position = "bottom-center",
    autoClose = 8000,
    hideProgressBar = false,
    closeOnClick = true,
    pauseOnHover = true,
    className = "text-center toast-notification",
    toastId
  } = params;

  toast.error(`${title}`, {
    position,
    autoClose,
    hideProgressBar,
    closeOnClick,
    pauseOnHover,
    className,
    toastId
  });
};

// Function to show a pending toast
export const ToastPending = (message, isShowToast = true) => {
  if (!isShowToast) {
    return null
  }
  return toast.loading(message, { theme: "dark" });
};

export const ToastSuccessPending = (toastId, title, isShowToast = true) => {

  if (!isShowToast) {
    return
  }

  if (toastId) {
    toast.update(toastId, {
      render: title,
      type: "success",
      isLoading: false,
      autoClose: 4000,
      theme: "dark",
    });

    return
  }
  ToastSuccess(title)
};

export const ToastErrorPending = (toastId, title) => {

  if (!title) {

    if (toastId) {
      toast.dismiss(toastId)
    }

    return
  }

  if (toastId) {
    toast.update(toastId, {
      render: title,
      type: "error",
      isLoading: false,
      autoClose: 4000,
      theme: "dark",
    });

    return
  }
  ToastError(title)
};

export const removeToast = toastId => {
  if (!toastId) return;
  toast.dismiss(toastId);
};

export const ToastDismiss = () => {
  toast.dismiss();
}